import { render, staticRenderFns } from "./spcodaccardTodo.vue?vue&type=template&id=71e930c6"
import script from "./spcodaccardTodo.vue?vue&type=script&lang=js"
export * from "./spcodaccardTodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports